import { useMutation } from '@apollo/client';
import { VehiculeProblem } from '../../shared/types';
import { CITRIN_UPDATE_VEHICULE_PROBLEM, UpdateVehiculeProblemRequest, UpdateVehiculeProblemResponse } from '..';

type UpdateMutationFunction = (request: VehiculeProblem) => Promise<VehiculeProblem>;
export const useUpdateVehiculeProblemMutation = (): { mutation: UpdateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<UpdateVehiculeProblemResponse, UpdateVehiculeProblemRequest>(
        CITRIN_UPDATE_VEHICULE_PROBLEM
    );

    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_updateVehiculeProblem;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
